import { Documento, ISdocumento } from "../../processo/Documento";
import { ISprocesso, Processo } from "../../processo/Processo";
import { ISusuarioList, UsuarioList } from "../../usuario/UsuarioList";


export interface DocumentoComentario {
    id: string;
    descricao: string;
    usuario: UsuarioList;
    dataHoraCriacao: Date | null;
    documento: Documento;
}

export const ISdocumentoComentario: DocumentoComentario = {
    id: "",
    descricao: "",
    usuario: ISusuarioList,
    dataHoraCriacao: null,
    documento: ISdocumento,
}